import payment from "@/plugins/api/factories/PaymentHistory";

export const state = {
  filterValues: null,
  paymentHistory: {},
  paymentHistoryEasyPay: {},
};

export const actions = {
  async getPaymentHistory({ commit, state }) {
    await payment.getPaymentHistory(state.filterValues, (response) => {
      commit("SET_PAYMENT_HISTORY", response.payments);
    });
  },
  async getPaymentHistoryFromEasyPayDb({ commit }, ls) {
    // return new Promise((resolve) => {
    await payment.getPaymentHistoryFromEasyPayDb(ls, (response) => {
        console.log(
          "getPaymentHistoryFromEasyPayDb response: ",
          JSON.stringify(response)
        );
        commit("SET_PAYMENT_HISTORY_EASY_PAY", response);
        // resolve(response);
      });
    // });
  },
};

export const mutations = {
  SET_FILTER_VALUES(state, filterValues) {
    state.filterValues = filterValues;
  },
  SET_PAYMENT_HISTORY(state, paymentHistory) {
    state.paymentHistory = paymentHistory;
  },
  SET_PAYMENT_HISTORY_EASY_PAY(state, paymentHistoryEasyPay) {
    state.paymentHistoryEasyPay = paymentHistoryEasyPay;
  },
  CLEAR_PAYMENT_HISTORY_EASY_PAY(state) {
    state.paymentHistoryEasyPay = {};
  },
};
